export const GET_TOUR_PROGRESS_REQUEST = "GET_TOUR_PROGRESS_REQUEST";
export const GET_TOUR_PROGRESS_SUCCESS = "GET_TOUR_PROGRESS_SUCCESS";
export const GET_TOUR_PROGRESS_FAIL = "GET_TOUR_PROGRESS_FAIL";

export const UPDATE_TOUR_PROGRESS_REQUEST = "UPDATE_TOUR_PROGRESS_REQUEST";
export const UPDATE_TOUR_PROGRESS_SUCCESS = "UPDATE_TOUR_PROGRESS_SUCCESS";
export const UPDATE_TOUR_PROGRESS_FAIL = "UPDATE_TOUR_PROGRESS_FAIL";

export const GET_TOUR_ONBOARDING_STATUS_REQUEST = "GET_TOUR_ONBOARDING_STATUS_REQUEST";
export const GET_TOUR_ONBOARDING_STATUS_SUCCESS = "GET_TOUR_ONBOARDING_STATUS_SUCCESS";
export const GET_TOUR_ONBOARDING_STATUS_FAIL = "GET_TOUR_ONBOARDING_STATUS_FAIL";

export const TOUR_ONBOARDING_STATUS_RESET = "TOUR_ONBOARDING_STATUS_RESET";
